<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <div class="AuctionModal" v-show="visible">
            <div class="AuctionModal-content">
                <div class="AuctionModal-content-group">
                    <div class="AuctionModal-header">
                        <div class="AuctionModal-logo">
                            <img src="~assets/img/logo.png" alt="Epic Moleskine">
                        </div>
                        <h1 class="AuctionModal-title">
                            {{ data.title }}
                        </h1>
                    </div>
                    <div class="AuctionModal-display" ref="display">
                        <youtube
                            video-id="nYa4g68UxlQ"
                            :width="playerWidth"
                            :height="playerHeight"
                        ></youtube>
                    </div>
                </div>
                <p class="AuctionModal-description">
                    {{ data.description }}
                </p>
                <a
                    class="AuctionModal-channel"
                    href="http://youtube.com"
                    ref="nofollow noreferrer"
                    target="_blank"
                >
                    <span class="AuctionModal-channel-text">Visita nuestro canal de Youtube <svg class="AuctionModal-channel-icon">
                            <use xlink:href="#icon-youtube"></use>
                    </svg></span>
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
import app from '@/app'
import BasicModal from "@/app/components/BasicModal";

export default {
    name: 'AuctionModal',
    components: {
        BasicModal,
    },
    data: () => ({
        visible: false,
        playerWidth: 0,
        playerHeight: 0,
    }),
    methods: {
        intro(el, done) {
            this.visible = true
            this.updatePlayerSize()
            app.resize.add(this.updatePlayerSize)
            done()
        },
        outro(el, done) {
            this.visible = false
            app.resize.remove(this.updatePlayerSize)
            done()
        },
        closeClickEmit() {
            this.$emit("closeClick");
        },
        updatePlayerSize() {
            const { $refs } = this
            this.playerWidth = $refs.display.offsetWidth
            this.playerHeight = $refs.display.offsetHeight
        },
    },
    computed: {
        data() {
            const { $store } = this
            return $store.getters.data.auction
        },
    },
}
</script>

<style src="styles/components/AuctionModal.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/AuctionModal.vue